/**
 * @packageDocumentation
 * @module dom/element
 */

import query_all from './query_all';

export interface QueryOne {
  /**
   * Query the DOM by ID, Query, or search ShadowDOM; and return the first element
   * @param query the tag name we are verifying
   * @param root a tag
   * @return true if Node, false otherwise
   */
  (query: string, root?: HTMLElement): Element | undefined;
}

/**
 * { @link QueryOne }
 */
export default (query: string, root?: HTMLElement): Element | undefined => {
  const $query = query_all(query, root);

  // @todo how do we communicate there is more than one?
  // @todo is no element best represented with `undefined`?
  return $query.length >= 1 ? $query[0] : undefined;
};
